import React from "react";

import { RadioGroupProps, useRadioGroup, Stack, Tag } from "@chakra-ui/react";

import { Option } from "../../../types";

import RadioCard from "./RadioCard";

import useTranslations from "../../../hooks/useTranslations";

type RadioCardGroupProps = Omit<RadioGroupProps, "children"> & {
  isDisabled?: boolean;
  options: Option[];
};

const RadioCardGroup = React.forwardRef<HTMLInputElement, RadioCardGroupProps>(
  ({ isDisabled = false, ...props }, ref) => {
    const t = useTranslations();
    const { getRootProps, getRadioProps } = useRadioGroup({
      ...props,
    });

    const group = getRootProps();

    return (
      <Stack spacing="3" w="full" {...group}>
        {props.options.map(({ label, value, isGoal }, index) => {
          const radio = getRadioProps({ value } as any, ref);

          return (
            <RadioCard
              key={value}
              isDisabled={isDisabled}
              isFocusable={!isDisabled}
              tag={
                isGoal ? (
                  <Tag variant="solid" colorScheme="purple">
                    {t("templates.targetLevel")}
                  </Tag>
                ) : undefined
              }
              index={index}
              {...radio}
            >
              {label}
            </RadioCard>
          );
        })}
      </Stack>
    );
  }
);

export default RadioCardGroup;
